module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/JofPHb/tc-custom/9781637151839.jpg?1698722651921",
      "alt": "This image is the cover for the book Scott Pilgrim Vol. 1: Precious Little Life, Scott Pilgrim"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Scott Pilgrim Vol. 1: Precious Little Life, Scott Pilgrim\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Scott Pilgrim's life is totally sweet. He's 23 years old, he's in a rock band, he's \"between jobs,\" and he's dating a cute high school girl. Nothing could possibly go wrong, unless a seriously mind-blowing, dangerously fashionable, rollerblading delivery girl named Ramona Flowers starts cruising through his dreams and sailing by him at parties. Will Scott's awesome life get turned upside-down? Will he have to face Ramona's seven evil ex-boyfriends in battle? The short answer is yes. The long answer is SCOTT PILGRIM, VOLUME 1: SCOTT PILGRIM'S PRECIOUS LITTLE LIFE.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Bryan Lee O'Malley\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Bryan Lee O'Malley is a Canadian cartoonist currently living in Los Angeles. His six-volume Scott Pilgrim series was a New York Times bestseller, an LA Times Book Prize finalist, and won an Eisner Award, two Harvey Awards, a Doug Wright Award, and a Joe Shuster Award. In 2010, Scott Pilgrim was adapted into a critically-acclaimed major motion picture (from Universal), video game (from Ubisoft), and the upcoming animated series on Netflix. His books (including Lost at Sea, Seconds, and Snotgirl) have been translated into over twenty languages.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Oni Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0